export default {
  'form.required': 'مطلوب',
  'input.good': 'جيد',
  //<!------- header ---------!>
  'header.book': 'الطيران',
  'header.upgradetobusiness': 'التحول إلى شريك',
  'header.checkin': 'الحجز',
  'header.manage': 'لوحة التحكم',
  'header.login': 'تسجيل الدخول',
  'header.signup': 'الاشتراك',
  'header.dashboard': 'لوحة القيادة',
  'header.logout': 'تسجيل الخروج',
  'header.ticket': 'الطلبات',
  'header.Booking': 'الحجز',
  'header.smarttripsi': 'تريبسي الذكية',
  'header.smarttripord': 'رحلة ذكية',
  'header.aboutus': 'معلومات عنا',
  'header.contactus': 'اتصل بنا',
  //<!------- footer ---------!>
  'footer.supports': 'دعمنا',
  'footer.onlinechat': 'الدردشة عبر الإنترنت',
  'footer.customer': 'خدمة العملاء',
  'footer.reserve': 'دعم الحجز',
  'footer.fax': 'فاكس',
  'footer.email': 'البريد الإلكتروني: Support.Tripsi.com',
  'footer.services': 'خدماتنا',
  'footer.flight': 'الطيران',
  'footer.hotel': 'الفنادق',
  'footer.tour': 'الجولات',
  'footer.who': 'من نحن',
  'footer.aboutus': 'معلومات عنا',
  'footer.contactus': 'اتصل بنا',
  'footer.members': 'الأعضاء',
  'footer.board': 'مجلس الإدارة',
  'footer.history': 'التاريخ',
  'footer.privacypolicy': 'الخصوصية والسياسة',
  'footer.privacy': 'الخصوصية',
  'footer.claim': 'مطالبة',
  'footer.rules': 'القواعد',
  'footer.address': 'العنوان',
  'footer.subscribe': 'اشترك في الأخبار',
  'footer.copyright':
    ' حقوق الطبع والنشر © 2018 Tripsi Inc، جميع الحقوق محفوظة',
  'footer.rules': 'القواعد',
  'footer.tourismMagazine': 'مجلة السياحة',
  'footer.customerClub': 'نادي العملاء',
  'footer.ticketGuide': 'دليل التذاكر',
  'footer.english': 'الإنجليزية',
  'footer.persian': 'الفارسية',
  //<!------- aboutus ---------!>
  'aboutus.tripsi': 'حول تريبسي',
  'aboutus.tripord': 'حول طريقة السفر',
  'aboutus.address':
    'العنوان: طهران، شارع الولي عصر، فوق زعفرانية، بجانب بنك الرفاهية، رقم 3061، الطابق 2، الوحدة 6',
  'aboutus.company': 'شركة تريبسي',
  'aboutus.iranphone': '021-22749095',
  'aboutus.canadaaddress': 'العنوان: 719-938 هاوس ستريت، فانكوفر',
  'aboutus.canadaphone': '001-7786828070',
  'aboutus.tripsiAboutus': `بدأت شركة طولو لخدمات السفر الجوي والحج في الصناعة السياحية الكبيرة في عام 1373. يعمل فريق طولو الكبير المكون من أكثر من 25 موظفًا، بما في ذلك المبيعات في طهران والقسم الفني في شيراز، دائمًا على تقديم أفضل الخدمات وأعلى جودة البرمجيات لإرضاء المقدمين الحاليين. بدأت هذه الشركة نشاطها في مجال الخدمات السياحية عبر الإنترنت تحت اسم تريبسي في عام 1401. تستند سياسة نظام تريبسي على رضا العملاء وأصحاب المصلحة وتقديم خدمات متميزة ومتميزة للعملاء.`,
  'aboutus.tripordAboutus':
    'في Tripord، نحن أكثر من مجرد منصة سفر عبر الإنترنت؛ نحن رفيقك الموثوق لتحويل رحلات الأحلام إلى واقع لا يُنسى. تأسست Tripord في عام 2021، حيث ولدت من خبرة تزيد عن عقدين في صناعة السفر، برؤية لخلق نظام بيئي سفر سلس، مبتكر، وشامل.',
  'aboutus.service1_tripsi': 'ممثل لجميع الخطوط الجوية المحلية والدولية',
  'aboutus.service2_tripsi': 'وكالة لبيع تذاكر الداخلية بالخارج',
  'aboutus.service3_tripsi': 'وكالة لبيع تذاكر الخارجية بشكل منظم ومرسوم',
  'aboutus.service4_tripsi': 'وكالة لبيع تذاكر الداخلية بشكل منظم ومرسوم',
  'aboutus.service5_tripsi': 'وكالة لتذاكر القطارات الدولية',
  'aboutus.service6_tripsi': 'إصدار تذاكر البدء من الخارج (SOTO)',
  'aboutus.service7_tripsi': 'تنظيم وإعداد الجولات الداخلية والخارجية',
  'aboutus.service8_tripsi': 'عقد الندوات والمؤتمرات المتخصصة',
  'aboutus.service9_tripsi':
    'تقديم خدمات في مسائل التأشيرات وخدمات السفارة، بما في ذلك (وقت السفارة واستلام جواز السفر)',
  'aboutus.service10_tripsi':
    'توفير خدمات نقل الإجراءات الجوية في المطار (CIP)',
  'aboutus.service11_tripsi': 'حجز الفنادق في جميع أنحاء إيران والعالم',
  'aboutus.service12_tripsi':
    'تنظيم قوافل الحج والحج والعمرة تحت إشراف الحج والعمرة',
  'aboutus.service1_tripord':
    'حول تريبورد: إعادة تعريف السفر، رحلة واحدة في كل مرة. في تريبورد، نؤمن بأن السفر يجب أن يكون سلسًا، شخصيًا، ولا يُنسى. مهمتنا هي تحويل طريقة استكشافك للعالم من خلال تقديم حلول ذكية، تجارب مُختارة بعناية، ودعم على مدار الساعة طوال أيام الأسبوع — كل ذلك في منصة واحدة. من الإقامات الفاخرة والسياحة البيئية إلى الوجهات المخفية وخلوات المزارع، نحن نوفر لك مغامرات استثنائية بأسعار تنافسية.',
  'aboutus.service2_tripord': 'لماذا تسافر معنا؟',
  'aboutus.service3_tripord':
    '• منصة شاملة: رحلات طيران، إقامات، جولات، والمزيد، مصممة خصيصًا لاحتياجاتك.',
  'aboutus.service4_tripord':
    '• الابتكار والثقة: تقنية متطورة، حجوزات آمنة، وأسعار شفافة.',
  'aboutus.service5_tripord':
    '• مكافآت ذات قيمة: اكسب واستخدم المزايا من خلال نادي الولاء تريبورد.',
  'aboutus.service6_tripord':
    '• دعم مخصص: مساعدة في أي وقت، ومن أي مكان، على مدار 365 يومًا في السنة.',
  'aboutus.service7_tripord':
    '• سفر مستدام: نحن نؤيد السياحة الصديقة للبيئة والتأثير الإيجابي على المجتمع.',
  'aboutus.service8_tripord':
    'بدعم من الخبرة وشغف الاكتشاف، تريبورد ليست مجرد خدمة سفر — بل هي شريكك الموثوق في صياغة رحلات تُلهمك.',
  'aboutus.service9_tripord': 'استكشف المزيد. قلّق أقل.',
  //<!------- dashboard ---------!>
  'dashboard.flightDescriptionTripsi':
    'شراء الرحلات الجوية الداخلية والدولية من تريبسي بأفضل سعر',
  'dashboard.flightDescriptionTripord':
    'شراء الرحلات الجوية الداخلية والدولية من تریپ اُرد بأفضل سعر',
  'dashboard.overview': 'نظرة عامة',
  'dashboard.book': 'حجز',
  'dashboard.search': 'بحث',
  'dashboard.reserve': 'صادر',
  'dashboard.staffs': 'الموظفين',

  'dashboard.random': 'عشوائي',
  'dashboard.stats': 'إحصائيات',
  'dashboard.overalview': 'نظرة شاملة',
  'dashboard.lastactivities': 'آخر الأنشطة',
  'dashboard.opportunities': 'الفرص',
  'dashboard.tickets': 'تم شراؤها',
  'dashboard.open': 'أخبار',
  'dashboard.rating': 'التقييم',
  'dashboard.openrequest': 'الطلبات المفتوحة',
  'dashboard.derik': 'ديريك',
  'dashboard.showmore': 'عرض المزيد...',
  'dashboard.onlinetickets': 'تذاكر عبر الإنترنت',
  'dashboard.favoritetrips': 'رحلاتي المفضلة',
  'dumb.amount_of_new_users': 'عدد المستخدمين الجدد: {amountOfUsers}',
  'dumb.display_width': '<strong>العرض: {width}</strong>',
  'dumb.display_height': '<strong>الارتفاع: {height}</strong>',
  /**Added by p.daneshmand */
  'confirmation.reject': 'لا',
  'confirmation.confirm': 'نعم',
  'confirmation.confirmTitle': 'تأكيد',
};
